export default __webpack_public_path__ + "static/media/team.4fe6e0c9.png";